import React, { useState } from 'react';

import Collapse from '@repo/editor/src/components/Collapse/Collapse';

import useWindowSize from 'global/utils/useWindowSize';
import { FlexColumn } from 'styles/layouts';

import { Wrapper, Text } from './styles';
import { collapseMobileTheme, collapseTheme } from './theme';

const FAQItem = ({ item }) => {
  const { isMobile } = useWindowSize();
  const [isActive, setIsActive] = useState(false);

  return (
    <Wrapper isActive={isActive}>
      <Collapse
        theme={isMobile ? collapseMobileTheme : collapseTheme}
        onChange={(panel) => setIsActive(panel !== null)}
      >
        <div label={item.title}>
          <Text as="div">{item.text}</Text>
        </div>
      </Collapse>
    </Wrapper>
  );
};

const FAQ = (props) => {
  return (
    <FlexColumn gap="24px">
      {props.items?.map((item, index) => (
        <FAQItem key={index} item={item} />
      ))}
    </FlexColumn>
  );
};

export default FAQ;
